import { SINGULAR_COUNT } from './selectionSummary.constants';
export var shouldShowSingularLabel = function shouldShowSingularLabel(count) {
  return count === SINGULAR_COUNT;
};